import React, { useEffect, useState } from "react"
import { ThemeProvider, CssBaseline } from "@material-ui/core"
import { createMuiTheme } from "@material-ui/core/styles"
import { useLocation, useHistory } from "react-router-dom"
import queryString from "query-string"
import AdminSubscriptionListContainer from "../../containers/AdminContainer/AdminSubscriptionListContainer"
import services from "../../services"

const darkTheme = createMuiTheme({
  palette: {
    type: "dark",
  },
})

function AdminSubscriptionsPage() {
  const location = useLocation()
  const history = useHistory()
  const queryParams = queryString.parse(location.search)
  
  const [subscriptions, setSubscriptions] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [currentPage, setCurrentPage] = useState(parseInt(queryParams.page) || 1)
  const [totalPages, setTotalPages] = useState(1)
  const [totalCount, setTotalCount] = useState(0)
  const [filters, setFilters] = useState({
    search: queryParams.search || "",
    status: queryParams.status || "",
    company_type: queryParams.company_type || "",
    start_date: queryParams.start_date || "",
    end_date: queryParams.end_date || "",
  })
  const perPage = 20

  const updateURL = (page, currentFilters) => {
    const params = {
      page: page > 1 ? page : undefined,
      search: currentFilters.search || undefined,
      status: currentFilters.status || undefined,
      company_type: currentFilters.company_type || undefined,
      start_date: currentFilters.start_date || undefined,
      end_date: currentFilters.end_date || undefined,
    }
    
    // Remove undefined values
    Object.keys(params).forEach(key => params[key] === undefined && delete params[key])
    
    const searchString = queryString.stringify(params)
    const newUrl = searchString ? `${location.pathname}?${searchString}` : location.pathname
    
    // Only update if URL actually changed
    if (location.pathname + location.search !== newUrl) {
      history.replace(newUrl)
    }
  }

  const fetchSubscriptions = async (page = currentPage, currentFilters = filters) => {
    try {
      setLoading(true)
      setError(null)

      const response = await services.subscriptionAdminServices.getSubscriptions(
        page,
        perPage,
        currentFilters,
      )

      if (response && response.data && response.data.data) {
        const { data } = response.data
        setSubscriptions(data.subscriptions || [])
        setTotalPages(data.total_pages || 1)
        setTotalCount(data.total_count || 0)
        setCurrentPage(data.current_page || page)
      } else {
        setSubscriptions([])
        setTotalPages(1)
        setTotalCount(0)
        setCurrentPage(1)
      }
    } catch (err) {
      console.error("Error fetching subscriptions:", err)
      setError(err.message || "Failed to load subscriptions")
      setSubscriptions([])
      setTotalPages(1)
      setTotalCount(0)
      setCurrentPage(1)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchSubscriptions(currentPage, filters)
    updateURL(currentPage, filters)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, filters])

  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage + 1) // Material-UI pagination is 0-based
  }

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters)
    setCurrentPage(1)
  }

  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <AdminSubscriptionListContainer
        subscriptions={subscriptions}
        loading={loading}
        error={error}
        currentPage={currentPage}
        totalPages={totalPages}
        totalCount={totalCount}
        onPageChange={handlePageChange}
        filters={filters}
        onFilterChange={handleFilterChange}
      />
    </ThemeProvider>
  )
}

export default AdminSubscriptionsPage
